import fetchDeviceService from '../../services/deviceRegistration/fetchDeviceService';

export const config = (countryCode) => {
  return {
    pageTitle: 'labels.deviceRegistration.heading',
    infoMessageTab1: 'labels.deviceRegistration.tabs.device.content',
    noExistingDevicesAlert:
      'labels.deviceRegistration.tabs.device.alert.noExistingDevices',
    searchText: 'labels.deviceRegistration.tabs.device.buttonText',
    searchingText:
      'labels.deviceRegistration.tabs.device.buttonSearchText',

    onSubmit: async (values, searchType) => {
      const dataResult = await fetchDeviceService.searchForDevice(
        values.deviceSerial?.trim(),
        countryCode,
        searchType,
      );
      return dataResult;
    },
    onChangeTab: () => {},
    formats: {
      date: 'dd mm yyyy',
    },
    tabs: [
      {
        id: 'Device',
        title: 'labels.deviceRegistration.tabTitle',
        optionsLabel:
          'labels.advancedSearch.tabs.patient.optionsLabel',

        searchOptions: [
          {
            label:
              'labels.advancedSearch.tabs.patient.searchOptions.current',
            value: 'current',
          },
          {
            label:
              'labels.advancedSearch.tabs.patient.searchOptions.currentAssociated',
            actionLabel:
              'labels.advancedSearch.tabs.patient.searchOptions.currentAssociated.actionLabel',
            value: 'current-associated',
            disabled: true,
          },
          {
            label:
              'labels.advancedSearch.tabs.patient.searchOptions.associated',
            value: 'associated',
            disabled: true,
          },
        ],
        findDevice: {
          searchType: 'serialNumber',
          title:
            'labels.deviceRegistration.tabs.device.radioGroupTitle',
          options: [
            {
              label:
                'labels.deviceRegistration.tabs.device.radioLabel.option1',
              value: 'serialNumber',
            },
            {
              label:
                'labels.deviceRegistration.tabs.device.radioLabel.option2',
              value: 'lotNumber',
            },
          ],
        },
        fields: [
          {
            id: 'deviceSerial',
            label: {
              serialNumber:
                'labels.deviceRegistration.tabs.device.searchField.serialNumber',
              lotNumber:
                'labels.deviceRegistration.tabs.device.searchField.lotNumber',
            },

            hint: {
              serialNumber:
                'labels.deviceRegistration.tabs.device.searchFieldHint.serialNumber',
              lotNumber:
                'labels.deviceRegistration.tabs.device.searchFieldHint.lotNumber',
            },
            validators: [
              {
                type: 'min',
                value: 5,
                message:
                  'labels.deviceRegistration.tabs.device.validations.minDigits',
              },
              {
                type: 'required',
                message:
                  'labels.deviceRegistration.tabs.device.validations.default',
              },
              {
                type: 'matches',
                value: /^[a-zA-Z0-9À-ȕ\d'\- *%]+$/g,
                message:
                  'labels.deviceRegistration.tabs.device.validations.specialChars',
              },
            ],
          },
        ],
        submitButtonLabel:
          'labels.advancedSearch.tabs.patient.submitButton',
        submitButtonTooltip:
          'labels.advancedSearch.tabs.patient.submitButtonTooltip',
      },
      {
        id: 'Accessory',
        title: 'labels.deviceRegistration.tabs.accessory.tabTitle',
        elements: {
          apifield: 'products',
          dataList: null,
          format: '',
          hidden: false,
          id: 'productFamily',
          label: 'labels.deviceRegistration.tabs.accessory.tabTitle',
          promptText: 'select',
          type: 'selectinput',
          validators: [
            {
              apifield: 'surgeon',
              type: 'predefined',
              key: 'required',
              mask: '',
              message: 'labels.deviceRegReview.validationPlaceholder',
            },
          ],
        },
      },
    ],
  };
};

export const dataTableConfig = () => {
  return {
    columns: [
      {
        display: 'labels.deviceRegistration.tabs.device.columnTitle1',
        field: 'description',
        format: {
          collapsed: {
            type: 'composite',
            template:
              '<div><span class="ccl__text ccl__text--interactive-text">{{deviceTypeLabel}}</span></div><div><em></em></div><div><span class="ccl__text ccl__text--body-text">{{description}}</span></div> <div><em></em></div>',
          },
          expanded: {
            type: 'emptycell',
          },
          onClick: () => {},
        },
        hiddenColumnView: 'mobile',
        sortable: false,
      },
      {
        display:
          'labels.deviceRegistration.tabs.device.columnTitle2.serialNumber',
        field: 'serialNumber',
        format: {
          type: 'string',
        },
        hiddenColumnView: 'mobile',
        sortable: false,
      },
    ],
    country: 'US',
    formats: {
      currency: 'USD',
      date: 'mmm dd, yyyy',
    },
    handleSortDataChange: () => {},
    language: 'en',
    highlight: false,
    clickableRow: true,
    isClinicPopup: false,
    events: {
      onLoadMore: () => {},
      onRowClick: () => {},
      onSort: () => {},
    },
  };
};

export const devicesData = [];

export const errorConfig = {
  imgSrc:
    'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTMwIiBoZWlnaHQ9IjUzMCIgdmlld0JveD0iMCAwIDUzMCA1MzAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMTguOTU4IDE5Ny4xNjVDMTgxLjc1NyAxNzAuNjA2IDE5MS4yODggMTc2LjQ4IDIzNC41NDEgMTE0LjQ5N0MzMjkgLTkwLjQ5OTggNTI4LjA2MyAyNSA1MjggMjkzLjIwMkM1MjcuOTM0IDU3My4wNDcgMTMzLjM4OSA1NTYuNzcyIDI0LjQ2NTUgMzkzLjMxOUMtMzIuMDI1NSAzMDguNTQ4IDMxLjE3MDYgMjIzLjc2NiAxMTguOTU4IDE5Ny4xNjVaIiBmaWxsPSIjRkNFRkQxIi8+CjxwYXRoIGQ9Ik0zOTMuMzE5IDM4NC4yNDVMMTQ2LjQzMiA0MjEuODg5QzE0NC4yNjcgNDIyLjI2NiAxNDIuMDM5IDQyMS44IDE0MC4yMDYgNDIwLjU4NkMxMzguMzczIDQxOS4zNzMgMTM3LjA3NSA0MTcuNTAzIDEzNi41NzcgNDE1LjM2MkMxMTYuNjM1IDMxNi43MDggMTAxLjc0NiAyMTIuMjE3IDg5LjI2NTEgMTA0LjQwMUM4OS4wNzIyIDEwMi4xOTEgODkuNzM5NCA5OS45OTIgOTEuMTI3OCA5OC4yNjJDOTIuNTE2MiA5Ni41MzIgOTQuNTE4NyA5NS40MDQ0IDk2LjcxNzkgOTUuMTE0M0wzNDMuNTExIDU3LjQ4NDVDMzQ1LjcxNyA1Ny4xMTcyIDM0Ny45OCA1Ny42MTYyIDM0OS44MjcgNTguODc3NEMzNTEuNjc0IDYwLjEzODYgMzUyLjk2MiA2Mi4wNjQ0IDM1My40MjMgNjQuMjUyOEMzNzMuMjgyIDE2Ni4yMDIgMzg5LjA2MSAyNjkuNzIyIDQwMC43NiAzNzQuODExQzQwMC45NzcgMzc3LjA0IDQwMC4zMjQgMzc5LjI2NyAzOTguOTM3IDM4MS4wMjVDMzk3LjU1IDM4Mi43ODMgMzk1LjUzNyAzODMuOTM3IDM5My4zMTkgMzg0LjI0NVoiIGZpbGw9IiNGMUJFNDgiLz4KPHBhdGggZD0iTTQ3NS4wNyAyMTAuMDQzQzQ3MC4yMjQgMTk0LjY1OCA0NjEuNjc4IDE4MC42OTcgNDUwLjE4MyAxNjkuMzgyQzQzOC42ODcgMTU4LjA2NyA0MjQuNTkyIDE0OS43NDQgNDA5LjEzMiAxNDUuMTQzQzM5My42NzMgMTQwLjU0MSAzNzcuMzIgMTM5LjgwMSAzNjEuNTA4IDE0Mi45ODhDMzQ1LjY5NiAxNDYuMTc1IDMzMC45MDcgMTUzLjE5IDMxOC40MzYgMTYzLjQyMUMzMDUuOTY2IDE3My42NTEgMjk2LjE5NSAxODYuNzg0IDI4OS45NzkgMjAxLjY2OEMyODMuNzYzIDIxNi41NTIgMjgxLjI5MyAyMzIuNzM0IDI4Mi43ODQgMjQ4Ljc5NUMyODQuMjc1IDI2NC44NTYgMjg5LjY4MyAyODAuMzA2IDI5OC41MzMgMjkzLjc5MUMzMDcuMzgyIDMwNy4yNzcgMzE5LjQwNCAzMTguMzg2IDMzMy41NDUgMzI2LjE0NkwyODEuNDIyIDQyNy40ODRDMjgwLjgxNSA0MjguNjYzIDI4MC43MDIgNDMwLjAzNSAyODEuMTA3IDQzMS4yOThDMjgxLjUxMiA0MzIuNTYgMjgyLjQwMiA0MzMuNjExIDI4My41ODEgNDM0LjIxN0MyODQuNzYgNDM0LjgyNCAyODYuMTMyIDQzNC45MzcgMjg3LjM5NSA0MzQuNTMyQzI4OC42NTggNDM0LjEyNyAyODkuNzA4IDQzMy4yMzcgMjkwLjMxNCA0MzIuMDU4TDM0Mi41MzQgMzMwLjUzMkMzNTQuNjU5IDMzNS43MTMgMzY3LjcwNyAzMzguMzg4IDM4MC44OTMgMzM4LjM5OEMzOTYuMzkxIDMzOC4zODggNDExLjY3IDMzNC43MzEgNDI1LjQ5NCAzMjcuNzIzQzQzOS4zMTggMzIwLjcxNSA0NTEuMjk4IDMxMC41NTIgNDYwLjQ2NyAyOTguMDU2QzQ2OS42MzYgMjg1LjU2IDQ3NS43MzUgMjcxLjA4MiA0NzguMjcyIDI1NS43OTJDNDgwLjgwOCAyNDAuNTAzIDQ3OS43MTIgMjI0LjgzMSA0NzUuMDcgMjEwLjA0M1pNNDA3LjY3MiAzMjQuMjQyQzM5MC45NTUgMzI5LjUxNiAzNzMuMDQ4IDMyOS43MTQgMzU2LjIxOCAzMjQuODEyQzMzOS4zODggMzE5LjkwOSAzMjQuMzg5IDMxMC4xMjYgMzEzLjExOSAyOTYuNjk5QzMwMS44NDkgMjgzLjI3MiAyOTQuODE0IDI2Ni44MDQgMjkyLjkwMyAyNDkuMzc5QzI5MC45OTIgMjMxLjk1NCAyOTQuMjkxIDIxNC4zNTMgMzAyLjM4MyAxOTguODAzQzMxMC40NzUgMTgzLjI1MiAzMjIuOTk2IDE3MC40NTEgMzM4LjM2NCAxNjIuMDE3QzM1My43MzEgMTUzLjU4MyAzNzEuMjU1IDE0OS44OTUgMzg4LjcxOCAxNTEuNDJDNDA2LjE4MSAxNTIuOTQ1IDQyMi44IDE1OS42MTUgNDM2LjQ3MyAxNzAuNTg1QzQ1MC4xNDYgMTgxLjU1NSA0NjAuMjU5IDE5Ni4zMzMgNDY1LjUzMyAyMTMuMDUxQzQ2OS4xMTMgMjI0LjE0OSA0NzAuNDUzIDIzNS44NDcgNDY5LjQ3NiAyNDcuNDY2QzQ2OC40OTkgMjU5LjA4NiA0NjUuMjI0IDI3MC4zOTYgNDU5Ljg0MSAyODAuNzRDNDU0LjQ1OSAyOTEuMDg0IDQ0Ny4wNzUgMzAwLjI1NiA0MzguMTIgMzA3LjcyM0M0MjkuMTY0IDMxNS4xOTEgNDE4LjgxNSAzMjAuODA2IDQwNy42NzIgMzI0LjI0MloiIGZpbGw9IiM2ODJCQzYiLz4KPHBhdGggZD0iTTMzOC42NTggMzQzLjgxOEwzMjQuNDIxIDMzNi4yNzJDMzE3Ljg0MyAzMzIuNzg2IDMwOS42ODMgMzM1LjI5MiAzMDYuMTk2IDM0MS44NzFMMjYyLjQ2MiA0MjQuMzg1QzI1OC45NzUgNDMwLjk2NCAyNjEuNDgxIDQzOS4xMjQgMjY4LjA2IDQ0Mi42MTFMMjgyLjI5NiA0NTAuMTU2QzI4OC44NzUgNDUzLjY0MyAyOTcuMDM0IDQ1MS4xMzcgMzAwLjUyMSA0NDQuNTU4TDM0NC4yNTYgMzYyLjA0M0MzNDcuNzQzIDM1NS40NjQgMzQ1LjIzNiAzNDcuMzA1IDMzOC42NTggMzQzLjgxOFoiIGZpbGw9IiM2ODJCQzYiLz4KPHBhdGggZD0iTTEzNi43NyAxNjEuMzY4QzEzMC42ODkgMTYxLjI1MSAxMjkuOTI2IDE1Mi40ODYgMTM2LjAzOCAxNTEuNDIyTDI4MC45NDYgMTI5Ljc3NUMyODIuMjU3IDEyOS41NzkgMjgzLjU5MyAxMjkuOTEyIDI4NC42NTkgMTMwLjcwMUMyODUuNzI1IDEzMS40OSAyODYuNDM0IDEzMi42NyAyODYuNjMgMTMzLjk4MUMyODYuODI2IDEzNS4yOTMgMjg2LjQ5MyAxMzYuNjI4IDI4NS43MDQgMTM3LjY5NEMyODQuOTE1IDEzOC43NiAyODMuNzM1IDEzOS40NjkgMjgyLjQyMyAxMzkuNjY1QzI4MS41MzUgMTM5LjczMyAxMzcuNTM2IDE2MS40MjMgMTM2Ljc3IDE2MS4zNjhaIiBmaWxsPSIjRkNFRkQxIi8+CjxwYXRoIGQ9Ik0xNDQuMDcyIDIxNC43NTVDMTQyLjgxOSAyMTQuNzQyIDE0MS42MTYgMjE0LjI2IDE0MC43MDEgMjEzLjQwM0MxMzkuNzg2IDIxMi41NDcgMTM5LjIyNiAyMTEuMzc4IDEzOS4xMzEgMjEwLjEyOEMxMzkuMDM3IDIwOC44NzggMTM5LjQxNSAyMDcuNjM5IDE0MC4xOSAyMDYuNjU0QzE0MC45NjYgMjA1LjY2OSAxNDIuMDgzIDIwNS4wMTIgMTQzLjMyIDIwNC44MTFMMjI1Ljk3MyAxOTIuMTI5QzIzMi41MDggMTkxLjMyNCAyMzQuMDEzIDIwMC43OTkgMjI3LjQ5IDIwMi4wMTNDMjI1Ljg5NiAyMDIuMTggMTQ1Ljc0MSAyMTQuNjg1IDE0NC4wNzIgMjE0Ljc1NVoiIGZpbGw9IiNGQ0VGRDEiLz4KPHBhdGggZD0iTTE1MS42ODQgMjY2LjYwNUMxNTAuNDM0IDI2Ni41OTMgMTQ5LjIzNCAyNjYuMTEzIDE0OC4zMTkgMjY1LjI2QzE0Ny40MDUgMjY0LjQwNyAxNDYuODQzIDI2My4yNDMgMTQ2Ljc0NCAyNjEuOTk3QzE0Ni42NDUgMjYwLjc1MSAxNDcuMDE2IDI1OS41MTMgMTQ3Ljc4NSAyNTguNTI2QzE0OC41NTMgMjU3LjU0IDE0OS42NjIgMjU2Ljg3NyAxNTAuODk1IDI1Ni42NjdMMTk5LjQ5NiAyNDguODM3QzIwNi4wMzYgMjQ3Ljk4NiAyMDcuNTkxIDI1Ny40NTEgMjAxLjA4NiAyNTguNzFMMTUyLjQ4NiAyNjYuNTRDMTUyLjIyIDI2Ni41ODMgMTUxLjk1MiAyNjYuNjA1IDE1MS42ODQgMjY2LjYwNVoiIGZpbGw9IiNGQ0VGRDEiLz4KPHBhdGggZD0iTTE1Ny45MjUgMzIwLjUxN0MxNTEuODQyIDMyMC4zOTcgMTUxLjA4NyAzMTEuNjU3IDE1Ny4xNyAzMTAuNTc1TDI0Ny42MjQgMjk2LjY0MUMyNTQuMTUyIDI5NS44MiAyNTUuNjczIDMwNS4zMDggMjQ5LjE0NiAzMDYuNTI0QzI0Ny41OTkgMzA2LjY4IDE1OS41MDcgMzIwLjQ2MyAxNTcuOTI1IDMyMC41MTdaIiBmaWxsPSIjRkNFRkQxIi8+Cjwvc3ZnPgo=',
  imgAlt: 'labels.errorMessage.imgAlt',
  imgWidth: 116,
  title:
    'labels.deviceRegistration.tabs.device.error.noResult.heading',
  text: 'labels.deviceRegistration.tabs.device.error.noResult.message',
  codeLabel: 'labels.errorMessage.codeLabel',
  layout: 'horizontal',
  buttons: [],
  handleCallback: () => {},
};
export const dataError = {};

export const errorConfigAPIError = {
  imgSrc:
    'https://mss-p-007-delivery.sitecorecontenthub.cloud/api/public/content/9bfd65ed69994fa49be3ff1339ea9674?v=cc7c6ec3',
  imgAlt: 'labels.errorMessage.imgAlt',
  imgWidth: 116,
  title:
    'labels.deviceRegistration.tabs.device.error.apiError.heading',
  text: 'labels.deviceRegistration.tabs.device.error.apiError.message',
  codeLabel: 'labels.errorMessage.codeLabel',
  layout: 'horizontal',
  buttons: [],
  handleCallback: () => {},
};

export const noExistingDevices = {
  imgSrc:
    'data:image/svg+xml;base64,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',
  imgAlt: 'labels.errorMessage.imgAlt',
  imgWidth: 116,
  title: 'labels.errorMessage.noExistingDevices.heading',
  text: 'labels.errorMessage.noExistingDevices.message',
  codeLabel: 'labels.errorMessage.codeLabel',
  layout: 'horizontal',
  buttons: [],
  handleCallback: () => {},
};

export const deviceAlreadyRegistered = {
  imgSrc:
    'https://mss-p-007-delivery.sitecorecontenthub.cloud/api/public/content/9bfd65ed69994fa49be3ff1339ea9674?v=cc7c6ec3',
  imgAlt: 'labels.errorMessage.imgAlt',
  imgWidth: 116,
  title: 'labels.errorMessage.deviceAlreadyRegistered.heading',
  text: 'labels.errorMessage.deviceAlreadyRegistered.message',
  codeLabel: 'labels.errorMessage.codeLabel',
  layout: 'horizontal',
  buttons: [],
  handleCallback: () => {},
};

export const dataAPIError = {};
export const modalConfig = (labels) => ({
  modaltitle:
    labels['labels.deviceRegistration.modalConfig.modaltitle'],
  size: 'xl',
  yes: labels['labels.deviceRegistration.modalConfig.yes'],
  no: labels['labels.deviceRegistration.modalConfig.no'],
  yesanalytics: 'yes_exit_register_device',
  noanalytics: 'no_exit_register_device',
  modalText:
    labels['labels.deviceRegistration.modalConfig.modalText'],
  onSuccess: () => {},
  onClose: () => {},
});
